<template>
  <div
    class="c-calendar__card"
    @dblclick="directLinkToEntries"
    :class="[{ 'has-projects' : hasProjects },{ 'is-holiday' : isHoliday}]"
  >
    <v-draggable
      tag="div"
      class="c-calendar__card-content"
      :data-date="$moment(date).format('YYYY-MM-DD')"
      :data-kolonne="kolonne_number"
      :data-weekdays="getWeekDayId"
      animation="150"
      group="week"
      v-model="daily_entries"
      @end="onEndDrag"
    >
      <template v-if="daily_entries.length > 0">
        <v-week-day-content
          :date="date"
          :index="index"
          :count="count"
          :comment="comment"
          :kolonne_number="kolonne_number"
          :first_entry="daily_entries[0]"
          :daily_entries="daily_entries"
          :is_holiday="isHoliday"
          @saveWeekDay="saveWeekDay"
        ></v-week-day-content>
      </template>

      <div v-else data-draggable="0">
        <div>
          <span class="c-calendar__comment u-color--primary" v-if="comment">
            <strong>{{ comment }}</strong>
          </span>
          <div class="c-calendar__hover-tools">
            <div class="c-calendar__hover-tool-grid grid-x grid-margin-x">
              <div class="cell small-6">
                <v-week-day-comment-only :comment="comment" @saveWeekDay="saveWeekDay"></v-week-day-comment-only>
              </div>
              <div class="cell small-6">
                <div class="c-calendar__create-button">
                  <router-link
                    :to="{ name : 'create-day', action: 'create-new', params: {date: this.date, kolonne: this.kolonne_number}  }"
                    class="button button--action button--action--create button--small"
                    :title="$t('weeks.project.add')"
                  >{{ $t('weeks.project.add') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span
        v-if="triggerSpinner"
        class="loading-wrapper is-loading"
        style="position: absolute; width: 100%;"
      >
        <span class="loading-message"></span>
      </span>
    </v-draggable>
  </div>
</template>

<script>
import WeekDayContent from "./weekDayContent";
import WeekDayCommentOnly from "./weekDayCommentOnly";
import draggable from "vuedraggable";

export default {
  name: "WeekDay",

  props: {
    row_id: {
      type: Number,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: null
    },

    date: {
      type: Date,
      default: null
    },
    kolonne_number: {
      type: String,
      default: ""
    },
    week_results: {
      type: Array,
      default: () => []
    },
    weekday_objects: {
      type: Array,
      default: () => []
    },
    holidays: {
      type: Object,
      default: {}
    }
  },

  components: {
    vWeekDayContent: WeekDayContent,
    vWeekDayCommentOnly: WeekDayCommentOnly,
    vDraggable: draggable
  },

  data: function() {
    return {
      first_entry: {},
      daily_entries: [],
      dragged_items: [],
      weekday_object: [],
      comment: "",
      triggerSpinner: false
    };
  },

  mounted: function() {
    this.createDays();
  },

  watch: {
    date: function(oldVal, newVal) {
      this.createDays();
    },
    week_results(oldVal, newVal) {
      this.createDays();
    },
    weekday_objects(oldVal, newVal) {
      this.createDays();
    }
  },

  computed: {
    getWeekDayId: function() {
      let weekdayId = null;
      if (this.weekday_object.id !== undefined) {
        weekdayId = this.weekday_object.id;
      }
      return weekdayId;
    },

    getWeekDayIds: function() {
      let weekdayIds = [];
      if (this.getWeekDayId !== null && this.weekday_objects.length >= 1) {
        this.weekday_objects.forEach(item => {
          //#TODO if weekdayid belongs to multiple projects
          if (this.kolonne_number == item.kolonne) weekdayIds.push(item.id);
        });
      }

      return weekdayIds;
    },

    hasProjects: function() {
      return this.daily_entries.length >= 1 ? true : false;
    },

    count: function() {
      return this.daily_entries.length;
    },

    isHoliday: function() {
      let currentDate = this.$moment(this.date);

      let sameDate = Object.entries(this.holidays).filter(element => {
        return currentDate.isSame(this.$moment(element[1].datum)); // this is based on the object structure of the holiday object
      });
      return sameDate.length >= 1 ? true : false;
    }
  },

  methods: {
    createDays: function() {
      this.daily_entries = [];
      let currentDate = this.$moment(this.date);

      let matches = [];
      matches = this.week_results.filter(row => {
        return (
          currentDate.isBetween(
            this.$moment(row.startdate),
            this.$moment(row.enddate),
            "days",
            "[]"
          ) && this.kolonne_number == row.kolonne
        );
      });

      if (matches.length > 0) {
        this.daily_entries = matches;
        this.first_entry = matches[0];
      }

      this.checkForWeekDayObject(currentDate);
    },

    checkForWeekDayObject: function(currentDate) {
      // used to fill our tooltip with comment field for example
      let matches = [];
      if (this.weekday_objects.length >= 1) {
        matches = this.weekday_objects.filter(row => {
          return (
            currentDate.isSame(this.$moment(row.date), "day") &&
            this.kolonne_number == row.kolonne
          );
        });

        if (matches.length > 0) {
          this.weekday_object = matches[0];
          this.comment = this.weekday_object["comment"];
        }
      }
    },

    onStartMove: function(event) {
      if (parseInt(event.dragged.dataset.draggable) === 0) {
        return false;
      }
    },

    onEndDrag: function(event) {
      this.$parent.$emit("onEndDragDrop", event);
      // empty day content
      this.weekday_object = [];
      this.comment = "";
    },

    directLinkToEntries: function() {
      this.$router.push({
        name: "update-day",
        params: {
          date: this.$moment(this.date).format("YYYY-MM-DD"),
          kolonne: this.kolonne_number
        }
      });
    },

    saveWeekDay: function(value) {
      this.triggerSpinner = true;
      if (this.weekday_object.id !== undefined) {
        if (value == "") {
          window.app.$helpers.logger(
            "Deleting weekday comment to database ..."
          );
          this.deleteWeekDay();
        } else {
          this.comment = value;
          Object.assign(this.weekday_object, { comment: value });
          window.app.$helpers.logger(
            "Updating weekday comment to database ..."
          );
          this.updateWeekDay();
        }
      } else {
        this.comment = value;
        window.app.$helpers.logger(
          "Saving new weekday comment to database ..."
        );
        this.createWeekDay();
      }
    },

    updateWeekDay: function() {
      let promise = this.$api
        .clearParams()
        .put("weekday/" + this.weekday_object.id + "/", this.weekday_object);

      promise
        .then(
          (response => {
            this.triggerSpinner = false;
            window.app.$helpers.logger(
              "Updating weekday comment to database is a success..."
            );
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    },

    deleteWeekDay: function() {
      let promise = this.$api
        .clearParams()
        .delete("weekday/" + this.weekday_object.id);

      promise
        .then(
          (response => {
            this.comment = "";
            this.weekday_object = [];
            window.app.$helpers.logger(
              "Deleting weekday comment to database is a success..."
            );
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        )
        .finally(
          (() => {
            this.triggerSpinner = false;
          }).bind(this)
        );
    },

    createWeekDay: function() {
      let body = {
        kolonne: this.kolonne_number,
        date: this.$moment(this.date).format("YYYY-MM-DD"),
        comment: this.comment
      };

      let promise = this.$api.clearParams().post("weekday", body);

      promise
        .then(
          (response => {
            this.triggerSpinner = false;
            this.weekday_object = response.data.data;
            window.app.$helpers.logger(
              "Creating weekday comment to database is a success..."
            );
          }).bind(this)
        )
        .catch(
          (error => {
            window.app.$helpers.logger(error);
          }).bind(this)
        );
    }
  }
};
</script>